import { TransformedData } from '../components/export-dialog';

export enum ENRICHMENT_STATE {
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum EnrichmentTypeEnum {
  ALL = 'PERSON,COMPANY,EMAIL,EMAIL_FINDER,EMAIL_VERIFIER',
  PERSON = 'PERSON',
  COMPANY = 'COMPANY',
  EMAIL = 'EMAIL',
  EMAIL_FINDER = 'EMAIL_FINDER',
  EMAIL_VERIFIER = 'EMAIL_VERIFIER',
}

export enum EnrichmentContentKey {
  URL = 'url',
  DOMAIN = 'domain',
  NAME = 'name',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  COMPANY_URL = 'companyUrl',
  BUSINESS_EMAIL = 'businessEmail',
}

export interface EnrichmentContent {
  [EnrichmentContentKey.URL]?: string;
  [EnrichmentContentKey.DOMAIN]?: string;
  [EnrichmentContentKey.NAME]?: string;
  [EnrichmentContentKey.FIRST_NAME]?: string;
  [EnrichmentContentKey.LAST_NAME]?: string;
  [EnrichmentContentKey.COMPANY_URL]?: string;
  [EnrichmentContentKey.BUSINESS_EMAIL]?: string;
}
export interface CreateEnrichmentRequest {
  type: EnrichmentTypeEnum;
  name: string;
  content: EnrichmentContent[];
  options: Array<unknown>;
  labels?: Array<unknown>;
  template?: {
    name: string;
    setting:
      | TransformedData
      | {
          company: {
            fields: string[];
          };
        };
  };
  user: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
  };
  overwriteOwner?: boolean;
}

export interface CreateEnrichmentResponse {}
